<template>
  <v-dialog scrollable max-width="450px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn x-small color="secondary" dark v-on="on" @click="init">
        Agregar detalle
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h4>Agregar Detalle</h4>
      </v-card-title>
      <v-card-text>
        <AsignacionAutocomplete :filtro="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
          14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
          28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
          42, 43, 44, 45, 46, 47, 48, 49, 50]" ref="asig" :asignacionId="asignacionId" @asignacionId="setAsignacionId" />
        <v-text-field type="text" label="Monto" v-model="monto"
          hint="Ingrese con singno negativo (-) para los decuentos ej: -25000" />

        <v-textarea auto-grow rows="1" type="text" label="Observacion" v-model="observacion"
          hint="Ingrese la descripcion del motivo del cambio" />

      </v-card-text>
      <div class="red--text" v-if="errorMessage">{{ errorMessage }}</div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import AsignacionAutocomplete from '@/components/shared/AsignacionAutocomplete.vue'


export default Vue.extend({
  props: ['texto', 'op'],
  components: {
    AsignacionAutocomplete
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      errorMessage: "",
      asignacionId: null,
      observacion: "",
      monto: "",
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() { },
  methods: {
    init() {
      this.errorMessage = "";
      this.monto = "";
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      this.loading = true;
      axios.post('/liquidacion/agregarDetalle', {
        ordenPagoId: this.op.id,
        asignacionId: this.asignacionId,
        monto: this.monto,
        observacion: this.observacion
      })
        .then((response) => {
          console.log(response);
          // this.$emit("nuevaCedula", {
          //   id: this.id,
          //   nuevaCedula: this.nuevaCedula,
          // });
          this.$emit("refresh");
          this.init();
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

      // this.$emit("detalleAgregado", {});
      // this.close();
    },
    setAsignacionId(id) {
      this.asignacionId = id;
    }
  },
});
</script>